module.exports = __webpack_public_path__ + "img/xbox-white.691195aa.png";